import _ from 'lodash'
import * as actionTypes from '../constants/actionTypes'

const initialState = {
  contactModalOpen: false,
  smsOptInModalOpen: false,
  source: '',
}

export default function propertyReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.TOGGLE_CONTACT_MODAL:
      return _.merge({}, state, {
        contactModalOpen: !state.contactModalOpen,
        source: action.source,
      })
    case actionTypes.DISPLAY_SMS_OPTIN_MODAL:
      return _.merge({}, state, {
        smsOptInModalOpen: action.value,
      })
    default:
      return state
  }
}

export { initialState }
